export default function getResource(label, vars = []) {
    const resources = {
        relatedSearchesTitle: 'Related Searches',
        searchForTerm: `Search for ${vars[0]}`,
        loadingRelatedSearches: 'Loading related searches'
    };

    return resources[label];
}
